'use strict';

bbw.shared.PhotoAlbumBaseCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', '$q', 'modelFactory', 'rpcClient', 'bbw.PhotoAlbumGallerySvc'],

    /**
     * @type {ngtk.model.Factory}
     */
    _modelFactory: undefined,

    /**
     * @type {ngtk.rpcClient.Client}
     */
    _rpcClient: undefined,

    /**
     * @type {bbw.model.PhotoAlbum}
     */
    _album: undefined,

    _albumScope: 'album',

    _galleryThemeClass: undefined,

    /**
     * @type {bbw.service.PhotoAlbumGallerySvc}
     */
    _bbwPhotoAlbumGallerySvc: undefined,

    _getGalleryControls: function() {
        return undefined;
    },

    openGallery: function(index) {
        this._bbwPhotoAlbumGallerySvc.openGallery(this._getGalleryControls(), this._album, index || 0, this._galleryThemeClass);
    },

    openGalleryAtMain: function() {
        var mainPhoto = this._album.findMainPhoto();
        this.openGallery(mainPhoto ? mainPhoto.$$idx : 0);
    },

    _init: function() {
        return this._initAlbum();
    },

    _initAlbum: function() {
        this._album = this._modelFactory.create(bbw.model.PhotoAlbum);
        this._wireAlbumScope();
        return this._album.load(this._getAlbumArguments());
    },

    _wireAlbumScope: function() {
        this._album.wireScope(this.$scope, this._albumScope);
    },

    /**
     * @abstract
     */
    _getAlbumArguments: function() {
        Class.abstractMethod();
    }

});
